module.exports = __webpack_public_path__ + "media/images/taco-9f31666e950c7a96bd442c8131e30f9f.png";